import Chip from "components/common/Chip";
import React from "react";
import DialogBase from "./DialogBase";

type PROPS = {
  flg: boolean;
  data?: { tag_name: string }[];
  close: (result: { tag_name: string }[]) => void;
};

const TagDialog: React.FC<PROPS> = (props) => {
  const [input, setInput] = React.useState("");
  const [tags, setTags] = React.useState<{ tag_name: string }[]>([]);

  const onAdd = () => {
    const value = input;
    setInput("");
    if (value === "") {
      return;
    }
    if (tags.find((v) => v.tag_name === value)) {
      return;
    }
    tags.push({ tag_name: value });
    setTags([...tags]);
  };
  const onRemove = (target: { tag_name: string }) => {
    const idx = tags.indexOf(target);
    tags.splice(idx, 1);
    setTags([...tags]);
  };

  React.useEffect(() => {
    if (!props.data) {
      return;
    }
    setTags([...props.data]);
  }, [props.data]);

  return (
    <DialogBase
      modalIsOpen={props.flg}
      title="タグの設定"
      close={() => {
        props.close(tags);
      }}
    >
      <div className="p-4 flex flex-col gap-4">
        <div className="p-2 flex items-baseline gap-4">
          <input
            className="w-96"
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
            }}
            disabled={tags.length >= 10}
          />
          <button
            className={`${ input.length === 0 || tags.length >= 10 ? 'secondary-disabled px-4 py-2' : 'primary px-4 py-2 '}`}
            onClick={onAdd}
            disabled={input.length === 0 || tags.length >= 10}
          >
            <span className="whitespace-nowrap">追加</span>
          </button>
        </div>
        <div className="border rounded-lg p-2">
          <div className="flex justify-between">
            <div>設定中のタグ</div>
            <div>{tags.length}/10</div>
          </div>
          <div className="my-4 flex flex-wrap gap-2">
            {tags.map((v, i) => {
              return (
                <Chip
                  key={i}
                  text={v.tag_name}
                  color="#d1d5db"
                  textColor="#000000"
                  onRemove={() => {
                    onRemove(v);
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </DialogBase>
  );
};

export default TagDialog;
